import {
  getDesignFormFields,
  THEME_GROUP_IDS,
} from '@/dashboard/scenes/PageEdit/scenes/PageDesign/theming/getDesignFormFields';

// `seller` gates feature-flagged sections out of the nav the same way
// getDesignFormFields gates them out of the form - a nav entry that scrolls to
// nothing still tells the seller the feature exists.
export const getDesignSections = ({ seller } = {}) => {
  // Get the form field sections
  const formFields = getDesignFormFields({
    themeValues: {},
    setFieldValue: () => {},
    values: {},
    seller,
    group: undefined,
    page: null,
    product: null,
    previewColorMode: null,
  });
  const formSections = formFields
    .filter(field => field.type === 'fieldgroup' && field.id)
    .map(field => {
      const headingField = field.fields?.find(f => f.type === 'heading');
      return {
        id: headingField.id,
        label: headingField?.label || field.id,
        overrideKeys: headingField?.resetKeys || [],
      };
    });

  // Split form sections into theme-level (Global, Columns, Cards) and element-level
  const themeSections = formSections.filter(s => THEME_GROUP_IDS.has(s.id));
  const elementSections = formSections.filter(s => !THEME_GROUP_IDS.has(s.id));

  return [
    { id: 'layout', label: 'Layout', overrideKeys: [] },
    { id: 'theme', label: 'Themes', overrideKeys: [] },

    // Brand sections are flattened to top-level
    ...themeSections,

    // Labels sits between Brand and Elements
    {
      id: 'custom-labels',
      label: 'Labels',
      overrideKeys: ['variables.labels'],
    },

    // Elements stays grouped
    { type: 'heading', label: 'Sections' },
    ...elementSections,

    // Custom CSS is a flat top-level item
    {
      id: 'custom-css',
      label: 'Custom CSS',
      overrideKeys: ['variables.customCss'],
      topLevel: true,
    },
  ];
};
